export default {
    TEXT: "text",
    PROJECTNUMBER: "project number",
    TYPE: "project type",
    PROJECTNAME: "project name",
    COMMENT: "comment"
}


// WEBPACK FOOTER //
// ./src/constants/ProjectPropertiesType.js